const getFilterOptions = (hasInternalUserAccess: boolean) => ({
  accounts: {
    groups: [
      {
        title: hasInternalUserAccess ? 'Account Type' : null,
        controls: hasInternalUserAccess
          ? [
              { property: 'folderTypes' as const, label: 'Client Company' },
              { property: 'folderTypes' as const, label: 'Program' },
              { property: 'folderTypes' as const, label: 'Participant' },
            ]
          : [],
      },
      {
        title: 'Preferences',
        controls: [
          { property: 'hideDeactivated' as const, label: 'Hide deactivated' },
          { property: 'excludeOptOut' as const, label: 'Hide Opt Outs' },
          // { property: 'hideNonProduction' as const, label: 'Hide non-production' }, // TODO: Not implemented in API, revisit after CEN-144 is complete
        ],
      },
    ],
  },
  people: {
    groups: [
      {
        title: hasInternalUserAccess ? 'Role' : null,
        controls: hasInternalUserAccess
          ? [
              { property: 'roleNames' as const, label: 'Super Admin' },
              { property: 'roleNames' as const, label: 'HSB Admin' },
              { property: 'roleNames' as const, label: 'Group Rep' },
              { property: 'roleNames' as const, label: 'Admin - Analyst' },
              { property: 'roleNames' as const, label: 'Location Manager' },
              { property: 'roleNames' as const, label: 'Notification Contact' },
              { property: 'roleNames' as const, label: 'Call Center' },
            ]
          : [],
      },
      {
        title: 'Preferences',
        controls: [{ property: 'hideDeactivated' as const, label: 'Hide deactivated' }],
      },
    ],
  },
  devices: {
    groups: [
      {
        title: 'Property',
        controls: [
          { property: 'properties' as const, label: 'Gateway' },
          { property: 'properties' as const, label: 'LoRa' },
          { property: 'properties' as const, label: 'Ammonia' },
          { property: 'properties' as const, label: 'Ting' },
          { property: 'properties' as const, label: 'Water Shutoff' },
        ],
      },
      {
        title: 'Preferences',
        controls: [
          { property: 'hideDeactivated' as const, label: 'Hide deactivated' },
          // { property: 'hideNonProduction' as const, label: 'Hide non-production' }, // TODO: Not implemented in API, revisit after CEN-144 is complete
        ],
      },
    ],
  },
  orders: {
    groups: [
      {
        title: 'Status',
        controls: [
          { property: 'statuses' as const, label: 'Submitted' },
          { property: 'statuses' as const, label: 'Fulfilled' },
          { property: 'statuses' as const, label: 'Shipped' },
          { property: 'statuses' as const, label: 'Delivered' },
        ],
      },
    ],
  },
})

export default getFilterOptions
